import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { GoalSection } from './components/GoalSection';
import { RouteSection } from './components/RouteSection';
import { SystemSection } from './components/SystemSection';
import { TomosSection } from './components/TomosSection';
import { BonusesSection } from './components/BonusesSection';
import { NotJustInfoSection } from './components/NotJustInfoSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ValueStackSection } from './components/ValueStackSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const PIXEL_ID = '2226605141499138';
export function App() {
  useEffect(() => {
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const first = document.getElementsByTagName('script')[0];
    first?.parentNode?.insertBefore(script, first);
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen w-full bg-cream font-sans text-ink selection:bg-coral selection:text-white" data-id="element-0" data-mp="3dlw4q1bpjt6b">
      <noscript data-id="element-1" data-mp="nuraocvicv35">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="nvasltl5rjh6" />
      </noscript>

      <Hero data-id="element-3" data-mp="38b2ajxh1886" />
      <main data-id="element-4" data-mp="3ud1g7bihxsbo">
        <ProblemSection data-id="element-5" data-mp="3udazkg91d18e" />
        <GoalSection data-id="element-6" data-mp="3ubzu8bzxzlf6" />
        <RouteSection data-id="element-7" data-mp="3ucj8niqdvrog" />
        <SystemSection data-id="element-8" data-mp="d4nvzht0nm2x" />
        <TomosSection data-id="element-9" data-mp="d4xp3e9cy9cu" />
        <BonusesSection data-id="element-10" data-mp="d3cw3t2oyyh3" />
        <NotJustInfoSection data-id="element-11" data-mp="d2l936n5u92f" />
        <TestimonialsSection data-id="element-12" data-mp="85uivqhn5x3a" />
        <ValueStackSection data-id="element-13" data-mp="86mh792mi8x9" />
        <PricingSection data-id="element-14" data-mp="86clr5yt79k6" />
        <GuaranteeSection data-id="element-15" data-mp="3gle8mfj3sxdl" />
        <FAQSection data-id="element-16" data-mp="3gkla21uate6j" />
        <FinalCTA data-id="element-17" data-mp="3gm665vw9h56i" />
      </main>
      <Footer data-id="element-18" data-mp="3gja887keygi2" />
      <PurchasePopup data-id="element-19" data-mp="3bmbf9schkflg" />
    </div>;
}